import {createRequestActionTypes} from "@pg-mono/request-state";

const LAST_SEEN_PROPERTIES_DETAILS_PREFIX = "last_seen_properties_details/fetch";
export const fetchLastSeenPropertiesDetailsTypes = createRequestActionTypes(LAST_SEEN_PROPERTIES_DETAILS_PREFIX);
